import Vue from 'vue'
import AudioPreview from './audioPreview.vue'

const MyAudioPreview = Vue.extend(AudioPreview)

AudioPreview.install = (Vue) => {
  return Vue.prototype.$AudioPreview = (options) => {
    let { url } = options
    let instance = new MyAudioPreview({
      data: {
        url,
      },
    }).$mount()
  
    document.body.appendChild(instance.$el)

    return instance.init()
  }
}

export default AudioPreview